/**
 * Build-time feature flags. Vite inlines `import.meta.env.VITE_*` at build, so a flag is
 * fixed for the lifetime of a deployment and toggled by redeploying with a different value.
 *
 * Every flag defaults to OFF: an unset variable must never switch a feature on in production.
 */
const isOn = (value: string | undefined): boolean => value?.trim().toLowerCase() === 'true';

/**
 * Task evidence uploads (`EvidencePanel` on the task detail page).
 *
 * Off until the API exposes `/api/v1/tasks/{id}/evidence`. The panel loads its list on mount,
 * so against an API without those routes every task page shows an evidence error. Set
 * `VITE_EVIDENCE_PANEL_ENABLED=true` (e.g. in `.env.development.local`, or in `.env.production`
 * once the API has shipped) to render it.
 */
export const evidencePanelEnabled = isOn(import.meta.env.VITE_EVIDENCE_PANEL_ENABLED);
